import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot, Slottable } from '../slot';
import { cardFooterRecipe } from './styles/card-footer.styles';
import type { CardFooterPropsInterface } from './types/card-footer.types';

/**
 * @since 10.0.0
 */
export const CardFooter = forwardRef<HTMLDivElement, CardFooterPropsInterface>(
  (props: CardFooterPropsInterface, forwardedRef) => {
    const { asChild = false, className, children, css: cssProp, divider = true, ...rest } = props;
    const styles = css(cardFooterRecipe.raw({ divider }), cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Card.Footer"
        className={cx('c11n', 'c11n_card__footer', styles, className)}
        {...rest}
      >
        <Slottable>{children}</Slottable>
      </Component>
    );
  },
);

CardFooter.displayName = 'Card.Footer';
